import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { CustomerImport } from "../../shared/models/customer.import.interface";
import { CustomerFilter } from "../models/customer.filter";
import { CustomerService } from "../services/customer.service";

export class CustomerImportDataSource implements DataSource<CustomerImport> {
  private customersSubject = new BehaviorSubject<CustomerImport[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private customerService: CustomerService) { }

  connect(collectionViewer: CollectionViewer): Observable<CustomerImport[]> {
    return this.customersSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.customersSubject.complete();
    this.loadingSubject.complete();
  }

  loadCustomers(filter: CustomerFilter,
    sortColumn = 'customerName', sortDirection = 'asc', pageIndex = 0) {

    this.loadingSubject.next(true);

    this.customerService.getImportList(filter, sortColumn, sortDirection, pageIndex).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(lessons => this.customersSubject.next(lessons));
  }
}
